// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"d383a8da","3307":"d383a8da","7754":"d383a8da","7934":"d383a8da","8498":"d383a8da"}[chunkId] + ".chunk.css";
};